<template>
  <c-box :display="{ base: 'contents', md: 'block' }">
    <c-box :display="{ base: 'inline-block', md: 'none' }" font-weight="bold" grid-area="label">
      {{ label }}
    </c-box>
    <c-text
      as="span"
      :background="getColor"
      :color="useColor && quantity !== '-' ? 'white' : 'black'"
      mt="-xs"
      :ml="{ base: '0.35rem', md: '0' }"
      :mr="{ base: '0.7rem', md: '0' }"
      py="0.35rem"
      px="md"
      border-radius="full"
      text-align="center"
      >{{ quantity }}</c-text
    >
  </c-box>
</template>

<script lang="ts">
import { CBox, CText } from "@chakra-ui/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Tag",
  components: {
    CBox,
    CText,
  },
  props: {
    quantity: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    useColor: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getColor() {
      if (this.quantity === "-") {
        return "transparent";
      }
      if (this.useColor) {
        return "brand.beigeDark";
      }
      return "gray.200";
    },
  },
});
</script>
